<div class="sm-rounded signature" [class.has-error]="hasError">
  <canvas #signaturePadCanvas *ngIf="!src" [width]="options.width" [height]="options.height"> </canvas>
  <img *ngIf="src" [src]="src" [height]="height" [width]="width" />
  <hr *ngIf="!src" class="hr signature-line sm-m-auto" />
</div>
